<template>
  <header class="fixed top-0 w-full z-40 bg-white shadow-md">
    <!-- Top Nav Bar -->
    <nav
      class="fixed w-full text-white h-16 py-0 z-50 transition-opacity duration-300 pointer-events-auto background-transparent"
      :style="{ opacity: navOpacity }"
    ></nav>
    <!-- Menu Button (Always Visible) -->
    <div class="container relative h-0 z-50">
      <div
        class="mx-auto flex items-center justify-end"
        :class="{
          'justify-end': !menuOpen,
          'justify-between': menuOpen,
        }"
      >
        <!-- Logo -->
        <router-link to="/" v-if="menuOpen">
          <img
            src="@/assets/logos/logoFilled.png"
            alt="Coast to Coast Adventures logo"
            class="h-16 w-16 mt-4"
          />
        </router-link>

        <!-- Menu Button -->
        <button
          ref="buttonRef"
          @click="toggleMenu"
          class="text-white focus:outline-none mt-2"
          aria-label="Toggle menu"
        >
          <span
            class="material-symbols-outlined align-middle text-3xl p-1 border-2 border-white rounded-md bg-stone-800"
          >
            menu
          </span>
        </button>
      </div>
    </div>

    <!-- Slide‐down Mobile Menu -->
    <transition name="slide-down">
      <div
        v-if="menuOpen"
        ref="menuRef"
        class="fixed inset-x-0 pt-20 z-40 bg-white flex flex-col items-center space-y-4 shadow-md pb-4"
      >
        <router-link class="text-black text-xl" @click="toggleMenu" to="/"
          >Home</router-link
        >
        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/all-trips"
          >All Trips</router-link
        >
        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/custom-trips"
          >Custom Trips</router-link
        >
        <router-link class="text-black text-xl" @click="toggleMenu" to="/about"
          >About Us</router-link
        >
        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/contact"
          >Contact Us</router-link
        >
        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/our-camps"
          >Our Camps</router-link
        >

        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/join-adventure"
          >Join an Adventure</router-link
        >
        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/family-trips"
          >Family Trips</router-link
        >
        <router-link
          class="text-black text-xl"
          @click="toggleMenu"
          to="/adventure-plus"
          >Adventure Plus!</router-link
        >
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuOpen: false,
      lastScroll: 0,
      visible: true,
      scrolledPastThreshold: false,
    };
  },
  computed: {
    isShowLogo() {
      if (this.$route.path === "/") {
        return this.scrolledPastThreshold || this.menuOpen;
      }
      return true;
    },
    navOpacity() {
      if (this.menuOpen) return 1;
      if (!this.scrolledPastThreshold) return 0;
      // Optional: implement a smooth ramp-up between 0 and 1
      const currentScroll = window.pageYOffset;
      const threshold = window.innerHeight * 0.2;
      const opacity = Math.min(currentScroll / threshold, 1);
      return opacity;
    },
  },
  watch: {
    // Prevent body from scrolling when menu is open
    menuOpen(newVal) {
      document.body.style.overflow = newVal ? "hidden" : "";
    },
  },
  mounted() {
    // 1) Listen to window scroll for hiding/showing header
    window.addEventListener("scroll", this.handleScroll);

    // 2) Listen to document clicks for “click-outside” logic
    document.addEventListener("click", this.onDocumentClick);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.onDocumentClick);
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleScroll() {
      const currentScroll = window.pageYOffset;
      const threshold = window.innerHeight * 0.2;

      this.lastScroll = currentScroll;
      this.scrolledPastThreshold = currentScroll > threshold;
    },
    onDocumentClick(e) {
      // If menu isn't open, we don’t care about outside clicks
      if (!this.menuOpen) return;

      // 1) If click happened on the toggle button, do nothing (toggleMenu already ran)
      const btn = this.$refs.buttonRef;
      if (btn && btn.contains(e.target)) {
        return;
      }

      // 2) If click happened inside the menu container, do nothing (user is interacting with links)
      const menu = this.$refs.menuRef;
      if (menu && menu.contains(e.target)) {
        return;
      }

      // Otherwise, click was outside both the button and the menu → close it
      this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
/* ─── Slide-Down / Slide-Up Animation ─── */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.25s ease;
}
.slide-down-enter-from {
  transform: translateY(-100%);
}
.slide-down-enter-to {
  transform: translateY(0);
}
.slide-down-leave-from {
  transform: translateY(0);
}
.slide-down-leave-to {
  transform: translateY(-100%);
}

/* Optional: style active router-links */
.router-link-active,
.router-link-exact-active {
  color: var(--color-sand);
}
</style>
